export default __webpack_public_path__ + "static/media/envelope.a57f73a2.svg";